var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"justify-space-between text-center",attrs:{"fixed":""}},[_c('h6',{staticClass:"mb-0 fw-normal w-100"},[_vm._v(_vm._s(_vm.copyrightText))])])}
var staticRenderFns = []

export { render, staticRenderFns }